var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01379 5.02603C5.01465 2.24951 7.24735 0 10.0001 0C12.7533 0 14.9864 2.25037 14.9864 5.02762C14.9864 7.80383 12.7534 10.0553 10.0001 10.0553H9.97107H9.9679C7.22335 10.0452 5.00474 7.79343 5.01379 5.02603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6025C7.93567 11.6025 6.00307 12.1105 4.55852 12.9335C3.1598 13.7304 2 14.9651 2 16.4937C2 17.2846 2.32216 17.9395 2.85293 18.4366C3.35783 18.9093 4.03009 19.2222 4.74585 19.4387C6.17523 19.8709 8.06323 20.0003 10 20.0003C11.9487 20.0003 13.8376 19.8658 15.2654 19.4277C15.9806 19.2083 16.6505 18.8921 17.1531 18.4171C17.681 17.9182 18 17.2633 18 16.4746C18 14.9426 16.8299 13.7133 15.4308 12.9228C13.9844 12.1056 12.0529 11.6025 10 11.6025Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsIcon);
export default __webpack_public_path__ + "static/media/friends-icon.1839cf336acd075ce48bab6f7129ee14.svg";
export { ForwardRef as ReactComponent };